// extracted by mini-css-extract-plugin
export default {"message":"_3V_Bd","countdown":"_1X54y","countdown-value":"_1bMY5","countdownValue":"_1bMY5","countdown-ended":"gFGsa","countdownEnded":"gFGsa"};